import { render, staticRenderFns } from "./emergencyuser.vue?vue&type=template&id=b02a4440&scoped=true&"
import script from "./emergencyuser.vue?vue&type=script&lang=js&"
export * from "./emergencyuser.vue?vue&type=script&lang=js&"
import style0 from "./emergencyuser.vue?vue&type=style&index=0&id=b02a4440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02a4440",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VCard,VDivider,VFlex,VIcon,VImg,VLayout,VListGroup,VNavigationDrawer})
